module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/awesome-typescript-loader/dist/entry.js!./discount-deals.ts"));
	}, "members-async-discount-deals");
}